var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35135 7.35174C7.16382 7.53922 6.90952 7.64453 6.64435 7.64453C6.37919 7.64453 6.12488 7.53922 5.93735 7.35174L0.280351 1.69475C0.0981922 1.50614 -0.00260162 1.25354 -0.000323296 0.991343C0.00195503 0.729147 0.107124 0.478334 0.292533 0.292926C0.477942 0.107518 0.728754 0.0023489 0.990951 7.05719e-05C1.25315 -0.00220776 1.50575 0.0985866 1.69435 0.280745L6.64435 5.23075L11.5944 0.280745C11.783 0.0985866 12.0356 -0.00220776 12.2978 7.05719e-05C12.5599 0.0023489 12.8108 0.107518 12.9962 0.292926C13.1816 0.478334 13.2867 0.729147 13.289 0.991343C13.2913 1.25354 13.1905 1.50614 13.0084 1.69475L7.35135 7.35174Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownAccordionArrow);
export default __webpack_public_path__ + "static/media/downAccordionArrow.7108249e9c7751bd13b8790f3e2779e6.svg";
export { ForwardRef as ReactComponent };